// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_bc-b";
export var colorBlue = "_bc-8";
export var colorDot = "_bc-0";
export var colorDotLarge = "_bc-2";
export var colorDotSmall = "_bc-1";
export var colorGreen = "_bc-7";
export var colorGrey = "_bc-3";
export var colorOrange = "_bc-5";
export var colorPink = "_bc-a";
export var colorPurple = "_bc-9";
export var colorRed = "_bc-4";
export var colorYellow = "_bc-6";